import type { Component } from 'vue';
import Dot from './Dot.vue';
import Menu from './Menu.vue';
export default new Map<string, Component>([
  ['Dot', Dot],
  ['Menu', Menu],

]);